import * as Util from "./_utilites"
import * as d3 from "d3"

/**
 * Map values with color range
 * @function
 * @param {String[]} elements_Ids - element unique ids
 * @param {String[]|Number[]} values - values of each element
 * @param {Boolean} sort - sort the values 
 * @return {[]}  - dictionary
 */
export function byUniqueVals(elements_Ids, values, sort)
{
  //console.log("getUnqieVals")
  if(elements_Ids.length !== values.length) return null ; // handle the error warning

  var uniqueVals = values.reduce(function (uniqueVals, field, index) {
    if (Object.keys(uniqueVals).includes(field)) uniqueVals[field].push(elements_Ids[index]);
    else {
      uniqueVals[field] = [];
      uniqueVals[field].push(elements_Ids[index]);
    }
    return uniqueVals;
  }, {})

  if(sort){
    var sortedKeys = Object.keys(uniqueVals).sort(Util.naturalSort);
    var sortedUniqueVals = {};
    for( let i = 0 ; i <sortedKeys.length; i++)
    {
      sortedUniqueVals[sortedKeys[i]] = uniqueVals[sortedKeys[i]];
    }
     return sortedUniqueVals;

  }
  else 
  {
    return uniqueVals;
  }

}

export function sortGroups(data, groupAttribute,)
{
  var sortedData = data.slice().sort((x, y) => d3.ascending(x[groupAttribute], y[groupAttribute]));
return sortedData;
}

export function simpleGroups(data, attribute){
  let groupedData = d3.group(data, d => d[attribute]);
  return Array.from(groupedData, ([key, value]) => ({key, value}));
}

/**
 * return unique values for a given attribute and the number of times it occured
 * @function
 * @param {Object[]} data - a dataset as flat array of objects
 * @param {String[]} attribute - object key to group by
 * @return {[{name:String, number:integer}]}  array of objects, each object with value name and value count
 */
export function simpleGroupSize(data, attribute){
  let countSummary = d3.rollup(data, v => v.length, d => d[attribute]);
  let countSummaryObj = Array.from(countSummary)
  let resultObj = countSummaryObj.map( i => ({name:i[0],number:i[1]}))
  return resultObj;
}

/**
 * return unique values for a given attribute and the sum of its values
 * @function
 * @param {Object[]} data - a dataset as flat array of objects
 * @param {String[]} groupAttribute - object key to group by
 * @param {String[]} sumAttribute - object key to sum
 * @return {[{name:String, number:integer}]}  array of objects, each object with value name and value sum
 */
 export function simpleGroupSum(data, groupAttribute, sumAttribute){
  let groupedSum = d3.rollups(data,
                              xSum => d3.sum(xSum, x => x[sumAttribute]),
                              d => d[groupAttribute])
                      .map(([group, num]) => ({ name: group, number: num }));
  return groupedSum;
}

/**
 * return unique values for a given attribute and the mean of its values
 * @function
 * @param {Object[]} data - a dataset as flat array of objects
 * @param {String[]} groupAttribute - object key to group by
 * @param {String[]} meanAttribute - object key to mean
 * @return {[{name:String, number:integer}]}  array of objects, each object with value name and value sum
 */
 export function simpleGroupMean(data, groupAttribute, meanAttribute){
  let groupedMean = d3.rollups(data,
                              xm => d3.mean(xm, x => x[meanAttribute]),
                              d => d[groupAttribute])
                      .map(([group, num]) => ({ name: group, number: num }));
  return groupedMean;
}

/**
 * return unique values for a given attribute and the Median of its values
 * @function
 * @param {Object[]} data - a dataset as flat array of objects
 * @param {String[]} groupAttribute - object key to group by
 * @param {String[]} calcAttribute - object key to calculate Median of
 * @return {[{name:String, number:integer}]}  array of objects, each object with value name and value sum
 */
 export function simpleGroupMedian(data, groupAttribute, calcAttribute){
  let groupedMedian = d3.rollups(data,
                              xc => d3.median(xc, x => x[calcAttribute]),
                              d => d[groupAttribute])
                      .map(([group, num]) => ({ name: group, number: num }));
  return groupedMedian;
}

/**
 * return unique values for a given attribute and the min of its values
 * @function
 * @param {Object[]} data - a dataset as flat array of objects
 * @param {String[]} groupAttribute - object key to group by
 * @param {String[]} calcAttribute - object key to calculate Min of
 * @return {[{name:String, number:integer}]}  array of objects, each object with value name and value sum
 */
 export function simpleGroupMin(data, groupAttribute, calcAttribute){
  let groupedMin = d3.rollups(data,
                              xc => d3.min(xc, x => x[calcAttribute]),
                              d => d[groupAttribute])
                      .map(([group, num]) => ({ name: group, number: num }));
  return groupedMin;
}

/**
 * return unique values for a given attribute and the Max of its values
 * @function
 * @param {Object[]} data - a dataset as flat array of objects
 * @param {String[]} groupAttribute - object key to group by
 * @param {String[]} calcAttribute - object key to calculate Max of
 * @return {[{name:String, number:integer}]}  array of objects, each object with value name and value sum
 */
 export function simpleGroupMax(data, groupAttribute, calcAttribute){
  let groupedMax = d3.rollups(data,
                              xc => d3.max(xc, x => x[calcAttribute]),
                              d => d[groupAttribute])
                      .map(([group, num]) => ({ name: group, number: num }));
  return groupedMax;
}
